import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Contact } from 'src/app/models/contact.model';
import { ContactService } from 'src/app/services/contact.service';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit, OnDestroy, AfterViewInit {
  id: any;
  contacts: Contact[];
  contactNew: Contact = new Contact();
  today: any;
  constructor(private contactService: ContactService, private router: Router) { }

  ngAfterViewInit(): void {

  }
  intervalList: any;
  items = [];
  pageSize: number = 50;
  count: any = 0;
  page: any = 1;
  checkAll: any;
  isDeleteMulti = true;
  ngOnInit(): void {
    this.loadContact();
  }

  loadContact() {
    this.today = Date.now();
    this.contactService.getContacts().subscribe(data => {
      this.contacts = data;
      this.count = data.length;
      if (this.contacts && this.contacts.length > 0) {
        this.contacts.map((obj) => {
          obj['checked'] = false;
          return obj;
        })
      }
    });
  }

  delete(id: string, contactName: string) {
    console.log('xóa');
    let that = this;
    if (confirm("Bạn có chắc chắn muốn xóa CBCC " + contactName + " ? ")) {
      that.contactService.deleteContact(id);
    }
  }

  deleteMulti() {
    let lstChecked = this.contacts.filter(item => { return item.checked == true; });
    if (confirm("Bạn có chắc chắn muốn xóa những tờ khai này? ")) {
      let lstId = lstChecked.map(({ id }) => id);
      this.contactService.deleteMultiContact(lstId);
      this.isDeleteMulti = true;
    }
  }

  closeModal() {
    this.contactNew = new Contact();
  }

  checkedItem() {
    let lstChecked = this.contacts.filter(item => { return item.checked == true; });
    this.isDeleteMulti = lstChecked && lstChecked.length > 0 ? false : true;
  }

  ngOnDestroy() {
    if (this.intervalList) {
      clearInterval(this.intervalList);
    }
  }

  onChangePage(event): void {
    this.page = event;
    this.loadContact();
  }

  createNewContact (){
    this.contactNew = new Contact();
  }

  saveContact() {
    if(this.contactNew.id){
      this.contactService.updateContact(this.contactNew);
    } else {
      this.contactService.createContact(this.contactNew);
    }
  }

  updateContact(contact) {
    this.contactNew = contact;
    document.getElementById("fakeUpdateButton").click();
  }
}
